import React from 'react'

import { Controller, useFormContext } from 'react-hook-form'
import { Grid, TextField } from '@material-ui/core'
import { KeyboardDatePicker } from '@material-ui/pickers'

import { AutocompleteTypeAndSearch, Card } from 'components'

const ChangesManagementQuestions = ({ isShow, responseUsers }) => {
  const { control, errors } = useFormContext()

  return (
    <Card title="Informações Gerais">
      <Grid container spacing={2}>
        <Grid xs={12} item>
          <Controller
            as={
              <TextField
                label="Nome da Mudança *"
                fullWidth
                variant="outlined"
                error={!!errors.name}
                helperText={errors?.name?.message}
                disabled={isShow}
              />
            }
            control={control}
            name="name"
            defaultValue=""
          />
        </Grid>
        <Grid xs={12} item>
          <Controller
            as={
              <TextField
                label="Mudança Planejada *"
                fullWidth
                variant="outlined"
                multiline
                minRows={3}
                error={!!errors.plannedChange}
                helperText={errors?.plannedChange?.message}
                disabled={isShow}
              />
            }
            control={control}
            name="plannedChange"
            defaultValue=""
          />
        </Grid>
        <Grid xs={6} item>
          <AutocompleteTypeAndSearch
            textField={{
              label: 'Responsável *',
              variant: 'outlined',
              error: !!errors?.responsibleId,
              helperText: errors?.responsibleId?.message,
            }}
            requestToLoadOptions={responseUsers}
            name="responsibleId"
            disabled={isShow}
            defaultValue=""
          />
        </Grid>
        <Grid xs={6} item>
          <AutocompleteTypeAndSearch
            textField={{
              label: 'Identificado Por *',
              variant: 'outlined',
              error: !!errors?.identifiedById,
              helperText: errors?.identifiedById?.message,
            }}
            requestToLoadOptions={responseUsers}
            name="identifiedById"
            disabled={isShow}
            defaultValue=""
          />
        </Grid>
        <Grid xs={4} item>
          <Controller
            control={control}
            name="openingDate"
            mode="onChange"
            defaultValue={null}
            as={
              <KeyboardDatePicker
                label="Data de Abertura *"
                fullWidth
                format="DD/MM/yyyy"
                inputVariant="outlined"
                onChange={(newValue) => ({ value: newValue })}
                error={!!errors?.openingDate}
                helperText={errors?.openingDate?.message}
                disabled={isShow}
                clearable
              />
            }
          />
        </Grid>
        <Grid xs={4} item>
          <Controller
            control={control}
            name="deadline"
            mode="onChange"
            defaultValue={null}
            as={
              <KeyboardDatePicker
                label="Prazo Previsto *"
                fullWidth
                format="DD/MM/yyyy"
                inputVariant="outlined"
                onChange={(newValue) => ({ value: newValue })}
                error={!!errors?.deadline}
                helperText={errors?.deadline?.message}
                disabled={isShow}
                clearable
              />
            }
          />
        </Grid>
        <Grid xs={4} item>
          <Controller
            control={control}
            name="conclusionDate"
            mode="onChange"
            defaultValue={null}
            as={
              <KeyboardDatePicker
                label="Data de Conclusão"
                fullWidth
                format="DD/MM/yyyy"
                inputVariant="outlined"
                onChange={(newValue) => ({ value: newValue })}
                error={!!errors?.conclusionDate}
                helperText={errors?.conclusionDate?.message}
                disabled={isShow}
                clearable
              />
            }
          />
        </Grid>
        <Grid xs={12} item>
          <AutocompleteTypeAndSearch
            textField={{
              label: 'Aprovado Por *',
              variant: 'outlined',
              error: !!errors?.approvedById,
              helperText: errors?.approvedById?.message,
            }}
            requestToLoadOptions={responseUsers}
            name="approvedById"
            disabled={isShow}
            defaultValue=""
          />
        </Grid>
        <Grid xs={12} item>
          <Controller
            as={
              <TextField
                label="Propósito da Mudança *"
                fullWidth
                variant="outlined"
                multiline
                minRows={3}
                error={!!errors.purposeOfChange}
                helperText={errors?.purposeOfChange?.message}
                disabled={isShow}
              />
            }
            control={control}
            name="purposeOfChange"
            defaultValue=""
          />
        </Grid>
      </Grid>
    </Card>
  )
}

export default ChangesManagementQuestions
